import React from 'react';

const Vdo = () => (
    <div class="embed-responsive embed-responsive-21by9">
  <iframe class="embed-responsive-item" src="https://www.youtube.com/embed/LpqA04yuGiY?start=1"></iframe>
</div>
)

export default Vdo;


